import gql from 'graphql-tag';

const QUERY_IS_LOGGED = gql`
  query IsLogged {
    isLogged
  }
`;

export const isLogged = client => () =>
  client.query({
    query: QUERY_IS_LOGGED,
    fetchPolicy: 'network-only'
  });

export default { isLogged };
